<template>
  <div class="side-right">
    <el-tag
      :class="[
        'tag',
        GET_ACTIVATE.split('?')[0] == tag.path.split('?')[0] ? 'current' : '',
      ]"
      :key="tag.path"
      v-for="tag in GET_TAGLIST"
      closable
      :disable-transitions="false"
      size="medium"
      @close="deleteTags(tag.path)"
      @click="btn(tag)"
    >
      {{ tag.name }}
    </el-tag>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["GET_TAGLIST"]),
    ...mapGetters(["GET_ACTIVATE"]),
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {},
  methods: {
    deleteTags(path) {
      this.$store.commit("deleteTagListChange", path);
    },
    btn(item) {
      if (this.$route.name !== "app") {
        this.$router.push({
          path: "/app",
        });
      }
      this.$store.commit("addTagListChange", {
        path: item.path,
        name: item.name,
      });
      this.$store.commit("activateChange", { activate: item.path });
      let arr = item.path.split("/");
      let name = arr[0];
      this.$microApp.setData(name, {
        isTag: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.side-right {
  padding: 20px 0;
  position: fixed;
  width: 0px;
  height: calc(100% - 75px);
  top: 59px;
  right: 0;
  z-index: 2000 !important;
  transition: all 0.5s;
  background: rgba($color: #f8f9fb, $alpha: 1);
  /* width: 1px;
  border-left: 1px solid #e3e2ec; */
  overflow-y: auto;
}
.side-right:hover {
  width: 95px;
}
.box {
  display: flex;
  padding-bottom: 6px;
  padding-top: 6px;
}
.tag {
  width: 80px;
  margin-left: 7px;
  display: block;
  position: relative;
  cursor: pointer;
  border-radius: 15px 4px 4px 15px;
  font-size: 14px;
  padding: 5px 12px;
  line-height: 19px !important;
  height: 30px !important;
  margin-bottom: 15px;
  background: #fff !important;
  border: 1px solid #e3e2ec !important;
  color: #585d69 !important;
}
.el-tag--medium {
  line-height: 19px !important;
}
.tag:hover {
  background: var(--primary-border-hover) !important;
  color: #fff !important;
  ::v-deep .el-tag__close {
    display: inline-block;
    color: #fff !important;
    display: inline-block;
  }
  ::v-deep .el-tag__close:hover {
    background-color: #fff !important;
    color: var(--primary) !important;
  }
}
::v-deep .el-tag__close {
  color: #fff !important;
  display: none;
  position: absolute !important;
  top: -9px !important;
  right: -8px !important;
  background: #fff;
  border: 1px solid #7c8898 !important;
}
::v-deep .el-tag__close::before {
  color: #7c8898 !important;
}
.current {
  background: var(--primary) !important;
  color: #fff !important;
  ::v-deep .el-tag__close {
    color: #fff !important;
  }
  ::v-deep .el-tag__close:hover {
    background-color: #fff !important;
    color: var(--primary) !important;
  }
}
</style>
